let React = require("react");

class Header extends React.Component {

    valueSelected(value, direcction){
        let sort = "";
        switch(true){
            case value === "name": sort = `name%20${direcction}`; break;
            case value === "pins": sort = `properties.pins%20${direcction}`; break;
            case value === "pitch": sort = `properties.pitch%20${direcction}`; break;
            case value === "body_length": sort = `properties.body_length%20${direcction}`; break;
            case value === "body_width": sort = `properties.body_width%20${direcction}`; break;
            case value === "height": sort = `properties.height%20${direcction}`; break;
            case value === "lead_span": sort = `properties.lead_span%20${direcction}`; break;
            case value === "lead_span2": sort = `properties.lead_span2%20${direcction}`; break;
            case value === "pitch2": sort = `properties.pitch2%20${direcction}`; break;
        }

        this.props.onSort(sort);
    }

    elementClicked(event, name){
        let { target: {dataset: {direction}}} = event;

        if(direction === "asc"){ 
            direction = "desc";
        }else{ 
            direction = "asc" 
        }
        this.valueSelected(name, direction);
        event.target.dataset.direction = direction;
        document.querySelector(`[value=${name}][data-direction=${direction}]`).selected = true;
    }

    getSelect(){
        return  <select onChange={(event) => this.valueSelected(event.target.value, event.target.selectedOptions[0].dataset.direction)}>
                    <option value="name" data-direction="asc">Name Ascending</option>
                    <option value="name" data-direction="desc">Name Descending</option>
                    <option value="pins" data-direction="asc">Pins Ascending</option>
                    <option value="pins" data-direction="desc">Pins Descending</option>
                    <option value="pitch" data-direction="asc">Pitch Ascending</option>
                    <option value="pitch" data-direction="desc">Pitch Descending</option>
                    <option value="body_length" data-direction="asc">Body Length Ascending</option>
                    <option value="body_length" data-direction="desc">Body Length Descending</option>
                    <option value="body_width" data-direction="asc">Body Width Ascending</option>
                    <option value="body_width" data-direction="desc">Body Width Descending</option>
                    <option value="height" data-direction="asc">Height Ascending</option>
                    <option value="height" data-direction="desc">Height Descending</option>
                    <option value="lead_span" data-direction="asc">Lead Span Ascending</option>
                    <option value="lead_span" data-direction="desc">Lead Span Descending</option>
                    <option value="lead_span2" data-direction="asc">Lead Span 2 Ascending</option>
                    <option value="lead_span2" data-direction="desc">Lead Span 2 Descending</option>
                    <option value="pitch2" data-direction="asc">Pitch 2 Ascending</option>
                    <option value="pitch2" data-direction="desc">Pitch 2 Descending</option>
                </select>
    }

    render() {
        return (
            <div className="header flex">
                <div className="header__items flex">
                    <div className="header__items__total">Total: {this.props.total}</div>
                    <div data-direction="asc" onClick={event => this.elementClicked(event, "name")}>Name</div>
                    <div data-direction="asc" onClick={event => this.elementClicked(event, "pins")}>Pins</div>
                    <div data-direction="asc" onClick={event => this.elementClicked(event, "pitch")}>Pitch</div>
                    <div data-direction="asc" onClick={event => this.elementClicked(event, "pitch2")}>Pitch 2</div>
                    <div data-direction="asc" onClick={event => this.elementClicked(event, "body_length")}>Body Length</div>
                    <div data-direction="asc" onClick={event => this.elementClicked(event, "body_width")}>Body Width</div>
                    <div data-direction="asc" onClick={event => this.elementClicked(event, "height")}>Height</div>
                    <div data-direction="asc" onClick={event => this.elementClicked(event, "lead_span")}>Lead Span</div>
                    <div data-direction="asc" onClick={event => this.elementClicked(event, "lead_span2")}>Lead Span 2</div>
                </div>
                <div className="header__sort spaceAround">Sort By {this.getSelect()}</div>
            </div>
        );
    }
}

module.exports = Header;
